import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var SidebarExpandSvg = function SidebarExpandSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.704 7.22 8.172 5.029-8.172 5.03zm1.481 7.407 3.865-2.378L7.185 9.87z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 2.249h20v20H2zm1.481 1.482v17.037h11.482V3.73zm12.963 0v17.037h4.075V3.73z",
    clipRule: "evenodd"
  }));
};
export var SidebarExpand = function SidebarExpand(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: SidebarExpandSvg
  }));
};